import React from 'react'
import { Button, Input } from '@arvoreeducacao/bonsai-ds'
import { useTranslation } from 'i18n'
import { useOrderCodeForm } from './OrderCodeForm.hooks'
import type { OrderCodeFormProps } from './OrderCodeForm.types'

export const OrderCodeForm: React.FC<OrderCodeFormProps> = ({ onRedeemed }) => {
  const { t } = useTranslation()
  const {
    code,
    isSubmitting,
    errorMessage,
    noticeMessage,
    canSubmit,
    handleCodeChange,
    handleSubmit
  } = useOrderCodeForm(onRedeemed)

  return (
    <form
      aria-labelledby="order-code-title"
      onSubmit={handleSubmit}
      noValidate
      className="flex flex-col gap-3 w-full rounded-[10px] border border-solid border-[#dfe5e9] bg-[#f9fafb] px-6 py-5 text-left"
    >
      <h2
        id="order-code-title"
        className="m-0 mb-1 text-center !text-[17px] font-bold text-[#2d2d2e]"
      >
        {t('Sua família comprou na Book Fair?')}
      </h2>
      <div className="flex flex-col">
        <Input
          id="order-code"
          name="order-code"
          type="text"
          label={t('Código do pedido')}
          aria-label={t('Código do pedido')}
          inputMode="text"
          autoComplete="off"
          autoCapitalize="characters"
          spellCheck={false}
          value={code}
          onChange={event => handleCodeChange(event.target.value)}
          error={Boolean(errorMessage)}
          helpText={
            errorMessage ??
            (noticeMessage ? undefined : 'Está no e-mail da compra.')
          }
          aria-invalid={Boolean(errorMessage)}
          className="w-full bg-white"
        />
        {errorMessage && (
          <p role="alert" className="sr-only">
            {errorMessage}
          </p>
        )}
        {noticeMessage && (
          <p
            role="status"
            className="m-0 mt-1 rounded-[8px] bg-white border border-solid border-[#dfe5e9] p-3 !text-[14px] leading-5 text-[#2d2d2e]"
          >
            {noticeMessage}
          </p>
        )}
      </div>
      <Button
        type="submit"
        theme={{ type: 'primaryLivros', size: 'xLarge' }}
        text={isSubmitting ? 'Liberando...' : 'Liberar meu acesso'}
        disabled={!canSubmit}
        fluid
      />
    </form>
  )
}
